import {
  fetchLoadActiveUserCount,
  fetchLoadDeepTestCount,
  fetchLoadReviewCount,
  fetchLoadSimpleMeasureCount,
  fetchLoadSimpleTestCount,
  fetchLoadUserTotalCount,
} from "api/admin/dashboard";
import DashboardChartLine from "components/admin/dashboard/dashboard.chart.line";
import DashboardChartPie from "components/admin/dashboard/dashboard.chart.pie";
import DashboardTotalBox from "components/admin/dashboard/dashboard.total.box";
import {
  DashboardCumulativeData,
  RetentionItem,
  SearchDateParams,
} from "interface/admin/interface.dashboard";
import { useEffect, useState } from "react";
import { ChartWrap } from "style/admin/dashboard";
import { StatisticsItemsWrap } from "style/admin/inquiry";
import { formatDateOnly, getTotalUserCount } from "utils/dashboard.util";
import { formatDateTime } from "utils/util";

// 누적 통계
const DashboardCumulativeStatistics = () => {
  const [data, setData] = useState<DashboardCumulativeData | null>(null);
  const [retentionData, setRetentionData] = useState<RetentionItem[]>([]);

  const today = new Date();
  const kstTimestamp =
    today.getTime() - today.getTimezoneOffset() * 60000 + 9 * 3600000;
  const now = new Date(kstTimestamp);

  useEffect(() => {
    const fetchAll = async () => {
      try {
        const fullParams: SearchDateParams = {
          searchStartDt: "2000-01-01T00:00:00.000Z",
          searchEndDt: formatDateTime(String(now)),
        };

        const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
        const monthParams: SearchDateParams = {
          searchStartDt: formatDateTime(String(monthStart)),
          searchEndDt: formatDateTime(String(now)),
        };

        const [
          userTotalCount,
          simpleTestCount,
          simpleMeasureCount,
          reviewCount,
          deepTestCount,
          activeUserCount,
        ] = await Promise.all([
          fetchLoadUserTotalCount(fullParams),
          fetchLoadSimpleTestCount(fullParams),
          fetchLoadSimpleMeasureCount(fullParams),
          fetchLoadReviewCount(fullParams),
          fetchLoadDeepTestCount(fullParams),
          fetchLoadActiveUserCount(monthParams), // 🔥 여기만 월별 파라미터
        ]);

        setData({
          userTotalCount: userTotalCount.result,
          simpleTestCount: simpleTestCount.result,
          simpleMeasureCount: simpleMeasureCount.result,
          reviewCount: reviewCount.result,
          deepTestCount: deepTestCount.result,
          activeUserCount: activeUserCount.result,
        });
      } catch (err) {
        console.error("통계 조회 실패:", err);
      }
    };

    fetchAll();
  }, []);

  useEffect(() => {
    const fetchRetentionData = async () => {
      const now = new Date();
      const dayList: string[] = [];

      // 10일 전부터 오늘까지 날짜 리스트 생성
      for (let i = 9; i >= 0; i--) {
        const d = new Date(now);
        d.setDate(now.getDate() - i);
        dayList.push(formatDateOnly(d)); // 예: "2025-04-08"
      }

      const requests = dayList.map(async (date) => {
        const startDt = `${date} 00:00:00`;
        const endDt = `${date} 23:59:59`;

        const res = await fetchLoadUserTotalCount({
          searchStartDt: startDt,
          searchEndDt: endDt,
        });

        const userCount =
          res.result?.reduce((sum: any, group: any) => {
            return sum + (group.maleCount || 0) + (group.femaleCount || 0);
          }, 0) ?? 0;

        return {
          date,
          userCount,
        };
      });

      try {
        const result = await Promise.all(requests);
        setRetentionData(result);
      } catch (err) {
        console.error("리텐션 데이터 조회 실패", err);
      }
    };

    fetchRetentionData();
  }, []);

  return (
    <StatisticsItemsWrap>
      {data ? <DashboardTotalBox data={data} /> : <div>loading...</div>}
      <ChartWrap>
        {retentionData && data && (
          <DashboardChartLine
            data={retentionData}
            userTotalCount={getTotalUserCount(data.userTotalCount)}
          />
        )}
        {data && <DashboardChartPie data={data.userTotalCount} />}
      </ChartWrap>
    </StatisticsItemsWrap>
  );
};

export default DashboardCumulativeStatistics;
